<div class="landing-wrapper">

  <header class="hero-section">
    <div class="hero-content">
      <span class="tag-new fadeInDown" appVisibility>Nueva Modalidad 2026</span>
      <h1 class="fadeInDown" appVisibility>La forma inteligente de enviar tus paquetes</h1>
      <p class="fadeInUp" appVisibility>Olvídate de pagar tarifas variables. Compra tus guías por volumen, congela el
        precio y úsalas cuando quieras durante todo un año.</p>
      <div class="hero-buttons fadeInUp" appVisibility>
        <button (click)="scrollTo('precios')" class="btn-primary">Ver Paquetes</button>
        <button (click)="scrollTo('como-funciona')" class="btn-outline">¿Cómo funciona?</button>
      </div>
    </div>
    <div class="hero-visual">
      <img src="assets/img/logistica-hero.png" alt="Logística Tufesa" class="hero-img"
        onerror="this.style.display='none'">
      <div class="hero-decoration">
        <div class="floating-card c1">📦 100 Envíos</div>
        <div class="floating-card c2">📉 Ahorro 30%</div>
      </div>
    </div>
  </header>

  <section class="comparison-section">
    <div class="container">
      <div class="text-center">
        <h2 class="fadeInUp" appVisibility>¿Por qué cambiarte a Guías Web?</h2>
        <p class="section-subtitle fadeInUp" appVisibility>La logística tradicional te quita tiempo. Nosotros te lo
          devolvemos.</p>
      </div>

      <div class="vs-grid">
        <div class="vs-card old-way fadeInUp" appVisibility>
          <h3>❌ Envíos Tradicionales</h3>
          <ul>
            <li>Hacer fila en sucursal cada vez.</li>
            <li>Pagar precios de mostrador (más altos).</li>
            <li>Llenar datos a mano en el mostrador.</li>
            <li>Sin control digital de tus gastos.</li>
          </ul>
        </div>

        <div class="vs-icon">VS</div>

        <div class="vs-card new-way fadeInUp" appVisibility>
          <h3>✅ Guías Web Tufesa</h3>
          <ul>
            <li><strong>Drop-off Rápido:</strong> Llegas y entregas.</li>
            <li><strong>Precio Mayorista:</strong> Ahorras hasta 30%.</li>
            <li><strong>Plataforma Web:</strong> Generas guías en segundos.</li>
            <li><strong>Facturación:</strong> Automática y organizada.</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section id="como-funciona" class="steps-section">
    <div class="container">
      <h2 class="fadeIn" appVisibility>Tan fácil como 1, 2, 3</h2>

      <div class="steps-grid">
        <div class="step-item fadeInUp" appVisibility>
          <div class="step-number">1</div>
          <div class="step-icon">🛒</div>
          <h3>Compra tu Pack</h3>
          <p>Elige el paquete que se ajuste a tu volumen mensual (10, 50 o 100 guías).</p>
        </div>

        <div class="step-line"></div>
        <div class="step-item fadeInUp" appVisibility>
          <div class="step-number">2</div>
          <div class="step-icon">💻</div>
          <h3>Genera la Guía</h3>
          <p>Entra a tu panel, pon los datos del destinatario e imprime la etiqueta.</p>
        </div>

        <div class="step-line"></div>

        <div class="step-item fadeInUp" appVisibility>
          <div class="step-number">3</div>
          <div class="step-icon">🚛</div>
          <h3>Entrega Express</h3>
          <p>Pega la etiqueta en tu caja y déjala en mostrador sin hacer filas.</p>
        </div>
      </div>
    </div>
  </section>

  <section class="use-cases-section">
    <div class="container">
      <div class="text-center">
        <h2 class="fadeIn" appVisibility>Ideal para tu negocio</h2>
        <p class="section-subtitle fadeIn" appVisibility>Mira quiénes ya están ahorrando con este modelo.</p>
      </div>

      <div class="cases-grid">
        <div class="case-card ecommerce fadeInUp" appVisibility>
          <div class="card-accent"></div>
          <div class="case-content">
            <h3>🛍️ Para E-Commerce</h3>
            <blockquote class="quote-box">
              "Vendo ropa y zapatos por Instagram. Necesito envíos rápidos y una tarifa fija para no perder margen de
              ganancia en cada venta."
            </blockquote>
            <div class="recommendation-box">
              <span class="label">Recomendamos:</span>
              <span class="pack-name">Pack Crecimiento (25 guías)</span>
            </div>
          </div>
        </div>

        <div class="case-card office fadeInUp" appVisibility>
          <div class="card-accent office-accent"></div>
          <div class="case-content">
            <h3>🏢 Para Oficinas</h3>
            <blockquote class="quote-box">
              "Enviamos documentación y refacciones entre sucursales cada semana. Necesitamos control fiscal y
              facturación simple."
            </blockquote>
            <div class="recommendation-box">
              <span class="label">Recomendamos:</span>
              <span class="pack-name">Pack Empresarial (50 guías)</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>

  <div id="precios" class="pricing-anchor">
    <app-guias-web-pricing [isDynamic]="true"></app-guias-web-pricing>
    <div class="cont-trust">
      <div class="trust-footer">
        <div class="trust-item">🔒 Compra 100% Segura</div>
        <div class="trust-item">🧾 Facturación Inmediata</div>
        <div class="trust-item">🚚 Cobertura Tufesa</div>
      </div>
      <div class="container">
        <div class="disclaimer-text"
          style="font-size: 0.7rem; color: #777; text-align: center; margin-top: 30px; padding: 0 15px 30px 15px;">
          Todo envío con origen en zona fronteriza deberá presentar factura fiscal del producto antes de su traslado. En
          caso de no contar con documentación válida, el paquete no será recibido ni enviado, conforme a disposiciones
          del SAT. La empresa no se hace responsable por retrasos o retenciones derivadas del incumplimiento.
        </div>
      </div>
    </div>


  </div>

  <section class="faq-section">
    <div class="container">
      <h2 class="fadeIn" appVisibility>Preguntas Frecuentes</h2>
      <div class="faq-grid">
        <div class="faq-item fadeInUp" appVisibility>
          <h4>¿Tienen fecha de caducidad?</h4>
          <p>Sí, tienes 12 meses (1 año) completos para usar tus guías a partir de la fecha de compra.</p>
        </div>
        <div class="faq-item fadeInUp" appVisibility>
          <h4>¿Incluye recolección?</h4>
          <p>Sí, todos nuestros paquetes web incluyen servicio de recolección a domicilio sin costo extra en zonas de
            cobertura.</p>
        </div>
        <div class="faq-item fadeInUp" appVisibility>
          <h4>¿Qué pasa si mi paquete pesa más?</h4>
          <p>Si compras guías de 5kg y tu paquete pesa 7kg, podrás pagar la diferencia de sobrepeso directamente en
            mostrador o plataforma.</p>
        </div>
      </div>
    </div>
  </section>

</div>